import CloseOutlinedIcon from '@mui/icons-material/CloseOutlined';
import IconButton from '@mui/material/IconButton';
import {Slide, ToastContainer} from 'react-toastify';

const Notifier = () => (
  <ToastContainer
    position="top-center"
    autoClose={5000}
    hideProgressBar
    icon={false}
    limit={5}
    newestOnTop
    closeOnClick={false}
    rtl={false}
    draggable={false}
    pauseOnHover
    theme="colored"
    transition={Slide}
    closeButton={({closeToast}) => (
      <IconButton
        aria-label="Close"
        size="small"
        onClick={closeToast}
        sx={{alignSelf: 'baseline', marginInlineEnd: -1}}
      >
        <CloseOutlinedIcon fontSize="small" color="inherit" />
      </IconButton>
    )}
  />
);

export default Notifier;
